module.exports = __webpack_public_path__ + "img/menu.b85cf807.svg";